export default (el) => {
  const countReviewsEl = el.querySelector('.js-count-reviews')
  const countQuestionEl = el.querySelector('.js-count-question')

  const reviewsEl = document.querySelector('#reviews')
  const questionEl = document.querySelector('#question')

  const countReviews = reviewsEl.getAttribute('data-count-reviews')
  const countQuestion = questionEl.getAttribute('data-count-question')

  countReviewsEl.innerHTML = countReviews
  countQuestionEl.innerHTML = countQuestion
}
